import { useMemo } from 'react';
import { userPermittedPolicyTypesFromTeam } from '../../../../../shared/permissions';
import { window } from '../../../../globals';
import type { Action } from '../../../../../typings/permissions';
import type { PolicyType } from '../../../../types';

/**
 * Checks the user's permissions and returns the policy types that
 * the user is permitted to perform the specified action.
 */
export default function useUserPermittedPolicyTypesFromTeam(action: Action): PolicyType[] {
  return useMemo(() => userPermittedPolicyTypesFromTeam(window.user?.permissions ?? [], action), [action]);
}
